<div class="fullscreen-process">
  <div aria-live="assertive" class="sr-only">
    @if (isSubmitting) {
      Eingabe wird verarbeitet.
    }
  </div>
  <mwe-wizard-header
    (cancelEvent)="cancelOnHeader()"
    [isClosingAllowed]="!isSubmitting && !wizardModel.isNotCancelable"
    [titleKey]="wizardModel.titleKey"
  />
  @if (wizardModel.wizardSteps.length > 1 && !wizardModel.hideProgressBar && progressBarVisibilityOverwrite) {
    <div class="progress thin">
      <div [style.width]="wizardStepWidth + '%'" aria-valuemax="100" aria-valuemin="0" class="progress-bar" role="presentation">
        <div aria-live="assertive" class="sr-only">
          {{ 'Schritt ' + currentWizardStepIdx + ' von ' + wizardModel.wizardSteps.length }}
        </div>
      </div>
    </div>
  }
  <main
    class="process-content px-4 pt-5 pt-lg-6 pb-6 pb-lg-9 {{ customCssClass }} container {{
      wizardModel.useMoreWidth ? 'limited' : 'is-medium'
    }}"
    role="main"
  >
    @if (imageUrl && !imageVisibilityOverwrite) {
      <img [src]="imageUrl" class="mb-6 w-100 rounded-1" />
    }
    @if (showAlert) {
      @if (alertType === 'danger') {
        <mwe-inline-notification #wizardAlert [messageKey]="alertMessageKey" [titleKey]="alertTitleKey" [type]="alertType" />
      } @else {
        <mwe-infobox #wizardAlert [messageKey]="alertMessageKey" [titleKey]="alertTitleKey" [type]="alertType" />
      }
    }
    @if (progressBarLabels && progressBarVisibilityOverwrite) {
      <mwe-progress-bar [labels]="progressBarLabels" [selectedIndex]="getCurrentProgressBarIndex()" class="d-block mb-5 mb-lg-6" />
    }
    @if (isWizardTitleVisible || isWizardSubTitleVisible) {
      <div class="mb-4 mb-lg-5">
        @if (isWizardTitleVisible) {
          <h1
            [ngClass]="currentWizardStep?.subTitleKey ? 'mb-1' : ''"
            [translate]="currentWizardStep.titleKey"
            data-test="wizard-title"
          ></h1>
        }
        @if (isWizardSubTitleVisible) {
          <p [innerHTML]="subTitle | translate | safeHtml" data-test="wizard-subtitle"></p>
        }
      </div>
    }
    <ng-content />
    @if (!buttonsHidden) {
      <div class="process-footer mt-5 mt-lg-6">
        <div class="buttons py-0" role="navigation">
          @if (
            nextButtonVisibleOverwrite && currentWizardStepHideNextButton !== true && (currentWizardStepNextLabel$ | async);
            as currentWizardStepNextLabel
          ) {
            <mwe-button
              (clicked)="submit()"
              [buttonId]="'mwe-wizard-submit'"
              [color]="currentWizardStep?.nextButtonColor || 'dark-blue'"
              [disabled]="isNextButtonDisabled || (currentWizardStepNextDisabled$ | async)"
              [labelKey]="currentWizardStepNextLabelOverwrite || currentWizardStepNextLabel"
              [showHoverEffect]="currentWizardStepIsPrimaryHoverButton"
              [showSpinner]="isSubmitting && currentWizardStep?.showPrimarySpinnerWhenLoading !== false"
              class="btn-container d-block primary"
            />
          }
          <div class="break"></div>
          @if (currentWizardStep?.skipNextStepButton) {
            <mwe-button
              (clicked)="nextWithSkip()"
              [buttonId]="'mwe-wizard-submit-with-skip'"
              [labelKey]="currentWizardStep.skipNextStepButton.label"
              class="btn-container d-block tertiary"
              color="blue"
            />
          }
          @if (prevButtonVisibleOverwrite) {
            @if (isPrevButtonVisible) {
              <mwe-button
                (clicked)="cancel()"
                [buttonId]="'mwe-wizard-cancel'"
                [color]="currentWizardStep?.prevButtonColor || 'dark-blue'"
                [disabled]="isSubmitting || buttonsDisabled"
                [labelKey]="currentWizardStepPrevLabel"
                category="secondary"
                class="btn-container d-block back"
              />
            }
            @if (currentWizardStep?.skipPrevStepButton) {
              <mwe-button
                (clicked)="cancelWithSkip()"
                [buttonId]="'mwe-wizard-cancel-with-skip'"
                [disabled]="isSubmitting || buttonsDisabled"
                [labelKey]="currentWizardStep.skipPrevStepButton.label"
                category="secondary"
                class="btn-container d-block back"
              />
            }
          }
          @if (currentWizardStepHidePrevButton === true && currentWizardStep?.textButtonKey) {
            <mwe-button
              (clicked)="openLink(currentWizardStep?.textButtonHref)"
              [buttonId]="'mwe-wizard-text-button'"
              [disabled]="buttonsDisabled"
              [labelKey]="currentWizardStep?.textButtonKey"
              category="secondary"
              class="btn-container d-block back"
            />
          }
        </div>
      </div>
    }
  </main>
  <ng-content select="#wizard-additional-footer" />
</div>
